// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports
import Box from "@mui/material/Box";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import {changeOwed} from "../../WorkIssuanceOwed/owedSlice";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import {changeWorkIssuance} from "../../workIssuanceSlice";


// main function
export default function DeferOwed({ onMenuClose, rowCdpStatus, showOwed, showExpense }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************



    const handleDefer = () => {
        // dispatchData(changeOwed({deferState: true, owedNewStatus: 'Deferred'}));
        dispatchData(changeWorkIssuance({newStatus:  '2043', updateCdpStatus: true}));
        onMenuClose();
    };


    return (

        <Box>
            {(
                    rowCdpStatus !== "2039" ||  rowCdpStatus !== "2351" ||  rowCdpStatus !== "2043"
                ) && showOwed === true &&
                <MenuItem onClick={handleDefer}>
                    <ListItemIcon>
                        <QuestionMarkIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Defer</ListItemText>
                </MenuItem>
            }
        </Box>

    )

}
